import { TbH1 } from "react-icons/tb";

export const physiosPageContent = {
    en: {
        contributeDb: {
            s: "Contribute",
            header: "Help build the database that helps your profession.",
            desc: `Revimo isn't built by a team sitting in an office — it's built with
              physiotherapists who know what good rehabilitation looks like. If
              you've developed exercises that work, share them.`,
            PERKS: {
                t1: "Submit your own exercises",
                desc1: "Add exercises you've developed in practice — with instructions, progressions, and contraindications.",

                t2:"Reviewed by the community",
                desc2: "Submissions go through a peer review process by partner professionals before going live.",

                t3: "Get credited for your work",
                desc3: "Your name and credentials are attached to every exercise you contribute to the database.",

                t4: "Shape the standard of care",
                desc4: "Help build a shared resource that raises the quality of physiotherapy rehabilitation globally.",
                
                t5: "Prizes for your contribution",
                desc5: "For contributing you get additional benefits, for more info please contact us.",
            },
        },
        exerciseDb: {
            s: "Exercise Database",
            header: "Hundreds of exercises, curated by professionals.",
            desc: `Access a continually growing library of exercises built and verified
            by partner physiotherapists and healthcare professionals. Filter by
            body region, condition, difficulty, or equipment — and assign
            directly to a patient plan in seconds.`,
            PERKS: {
                t1: "Filter by body region, condition, difficulty, and equipment" ,
                t2: "Every exercise verified by licensed partner professionals",
                t3: "Video demonstrations and written instructions included",
                t4: "Database grows over time as contributors add content",
                t5: "One-click assignment to any active patient plan",
                t6: "Evidence-based content, version-controlled and auditable",
            },
            important: {
                l1: "Exercises at launch",
                l2: "Body regions covered",
                l3: "Partner professionals",
                l4: "Growing with you",
            },
        },
        patientExperience: {
            s:"Patient Experience",
            header: "Your patients stay engaged between sessions.",
            desc: `When you assign a plan, your patient gets access to their own
          personalised section of Revimo — a guided experience designed to keep
          them motivated, consistent, and on track with their recovery.`,
            PERKS: {
                t1: "Personalised patient dashboard",
                desc1: "Each patient sees only their own plan — structured, clear, and easy to follow without supervision.",

                t2:"Step-by-step exercise guidance",
                desc2: "Video instructions and written cues mean patients can perform exercises correctly even at home.",

                t3: "Session logging & feedback",
                desc3: "Completed sessions are logged and patients answer to short answers — giving you real clinical data.",

                t4: "Progress tracking over time - (Under development)",
                desc4: "Patients can see their own improvement, which drives motivation and adherence to the plan.",
            },
        },
        physioCTA: {
            s: "Get Started",
            title: "Ready to work smarter?",
            desc: `Join the physiotherapists that will also use Revimo. Get on waitlist, and get 
          space for 5 more patients for free!`,
            join: "Join Testing!",
            pricing: "Pricing",
            war: "Payments are required - see pricing for more details.",

        },
        physioHero: {
            s: "For Physiotherapists",
            t1: "The platform that works",
            t2: "as hard as you do",
            desc: `
            Revimo gives physiotherapists access to a growing exercise database,
          powerful plan-building tools, and a direct connection to their patients
          — so you can focus on the cases that need you most.`,
            join: "Be an early user, give us your feedback.",
            pricing: "Pricing"
        },
        physiosPos: {
            s: "Our Philosophy",
            t1: "Revimo doesn't replace physiotherapists — it amplifies them.",
            desc1: `The best patient outcomes happen when a skilled physiotherapist is
            fully present — listening, assessing, adjusting. Revimo handles the
            repetitive logistics and sessions that eat into that time.`,
            desc2: `Routine plan delivery, exercise guidance, and patient progress
            tracking are automated and structured. That gives you back the
            bandwidth to take on more complex cases, build deeper therapeutic
            relationships, and deliver better care to every client!`,
            imp: "You stay the expert. Revimo makes sure your expertise reaches further.",
        },
        tableOfCon: {},
        treatmentP: {
            s: "Treatment Plans",
            header: "Design plans as individual as your patients.",
            desc: `No two patients are the same. Revimo's plan builder will give you full
          control over every variable — from exercise selection to progression
          logic. Delivering results instantly to your patients personal account.`,
            PERKS: {
                title1: "Build a personalised plan",
                desc1: "Select exercises from the database, set reps, sets, frequency, and progression targets — all in one flow.",
     
                title2: "Assign it to your patient",
                desc2: "The plan appears instantly in your patient's Revimo section, ready to follow on their own time.",
                
                title3: "Monitor progress remotely",
                desc3: "Track completion rates, adherence, and patient-reported feedback without a phone call.",

                title4: "Adjust as they improve",
                desc4: "Update exercises, swap difficulty levels, or add new phases — changes sync to the patient immediately.",
            },
        },
        whyR: {
            s: "Why Revimo",
            header: "Everything you need. Nothing you don't.",
            desc1: `Revimo was built around one question: How can we decrease waiting lines
          without compromising the quality and professionality of treatment? `,
            desc2: "This not only affects the clients and patients, but also YOU physiotherapists!",
            desc3: "Our goal at Revimo is to make physiotherapy easier and better for both sides.",
            PERKS: {
                t1: "More time for complex cases",
                d1: "Routine plan delivery and patient follow-up are handled by the platform, freeing you for patients who need you most.",

                t2: "Better patient adherence",
                d2: "Structured digital plans with guided instructions increase the likelihood patients actually complete their exercises.",

                t3: "Stay connected between sessions",
                d3: "Monitor progress, receive feedback, and spot issues before the next appointment — without a single phone call.",

                t4: "Built with physiotherapists",
                d4: "Every feature was designed in collaboration with licensed professionals, not just software engineers.",

                t5: "Clinically sound content",
                d5: "All database exercises are peer-reviewed and evidence-based. You can assign with confidence.",

                t6:"Scales with your practice",
                d6: "Whether you have 10 patients or 200, Revimo handles the complexity so you don't have to.",
            },
        },
    },
    sl: {
        
        contributeDb: {
            s: "Prispevanje",
            header: "Sodelujte pri oblikovanju baze, ki podpira vašo stroko.",
            desc: `Revimo ne nastaja zgolj v pisarnah — razvija se v sodelovanju s
            fizioterapevti, ki razumejo, kaj pomeni kakovostna rehabilitacija. Če
            ste razvili učinkovite vaje, jih delite z drugimi.`,
            PERKS: {
                t1: "Oddajte lastne vaje",
                desc1: "Dodajte vaje iz svoje prakse — z natančnimi navodili, progresijami in kontraindikacijami.",

                t2: "Strokovni pregled",
                desc2: "Vsak prispevek pred objavo pregledajo partnerski strokovnjaki.",

                t3: "Priznanje za vaše delo",
                desc3: "Vaše ime in strokovne reference so navedene pri vsaki vaji, ki jo prispevate. ",

                t4: "Soustvarjanje standardov",
                desc4: "Prispevajte k skupni bazi, ki dviguje kakovost fizioterapevtske obravnave na širši ravni.",

                t5: "Nagrade za vaše prispevanje",
                desc5: "Za prispevanje vaj lahko dobite dodatne ugodnosti za več informacij nam pišite na ",

            },
        },
        exerciseDb: {
            s: "Baza vaj",
            header: "Obsežna zbirka vaj, pripravljena s strani strokovnjakov.",
            desc: `Dostopajte do nenehno rastoče zbirke vaj, ki jih pripravljajo in
            preverjajo partnerski fizioterapevti ter zdravstveni strokovnjaki.
            Filtrirajte po delu telesa, stanju, zahtevnosti ali opremi ter jih
            v nekaj trenutkih vključite v pacientov načrt.`,
            PERKS: {
                t1: "Filtriranje po delu telesa, stanju, zahtevnosti in opremi",
                t2: "Vsaka vaja je strokovno preverjena",
                t3: "Vključeni video prikazi in pisna navodila",
                t4: "Baza se stalno dopolnjuje z novimi vsebinami",
                t5: "Enostavna vključitev v pacientov načrt",
                t6: "Vsebine temeljijo na dokazih ter omogočajo sledljivost sprememb",
            },
            important: {
                l1: "Število vaj ob lansiranju",
                l2: "Pokriti deli telesa",
                l3: "Sodelujoči strokovnjaki",
                l4: "Razvoj skupaj z uporabniki",
            },
        },
        patientExperience: {
            s: "Izkušnja pacienta",
            header: "Pacienti ostanejo aktivno vključeni tudi med obravnavami.",
            desc: `Ob dodelitvi načrta pacient pridobi dostop do svojega
            prilagojenega dela platforme Revimo — vodenega okolja, zasnovanega za
            spodbujanje motivacije, doslednosti in napredka pri rehabilitaciji.`,
            PERKS: {
                t1: "Prilagojen pregled nad načrtom",
                desc1: "Pacient vidi izključno svoj načrt — jasno strukturiran in enostaven za samostojno izvajanje.",

                t2: "Vodenje skozi vaje",
                desc2: "Video prikazi in pisna navodila omogočajo pravilno izvajanje vaj tudi doma.",

                t3: "Beleženje izvajanja in povratne informacije",
                desc3: "Izvedene aktivnosti se beležijo, pacienti pa podajo kratke odgovore, kar omogoča vpogled v dejanske podatke.",

                t4: "Spremljanje napredka skozi čas (v razvoju)",
                desc4: "Pacienti lahko spremljajo svoj napredek, kar spodbuja motivacijo in doslednost.",
            },
        },
        physioCTA: {
            s: "Začetek",
            title: "Ste pripravljeni na učinkovitejše delo?",
            desc: `Pridružite se fizioterapevtom, ki bodo uporabljali Revimo. Vpišite se na čakalni seznam in
            pridobite možnost brezplačne obravnave za dodatnih 5 pacientov.`,
            join: "Začnite s testiranjem",
            pricing: "Cenik",
            war: "Uporaba je plačljiva — več informacij v ceniku.",
        },
        physioHero: {
            s: "Za fizioterapevte",
            t1: "Platforma, ki deluje",
            t2: "z enako predanostjo kot vi",
            desc: `
            Revimo fizioterapevtom omogoča dostop do rastoče baze vaj,
            naprednih orodij za oblikovanje načrtov ter neposredno povezavo s pacienti,
            kar omogoča osredotočenost na zahtevnejše primere.`,
            join: "Postanite zgodnji uporabnik, začnite testirati.",
            pricing: "Cenik"
        },
        physiosPos: {
            s: "Naša usmeritev",
            t1: "Revimo ne nadomešča fizioterapevtov — temveč krepi njihovo delo.",
            desc1: `Najboljši rezultati se dosežejo, ko je fizioterapevt v celoti
            prisoten — posluša, ocenjuje in prilagaja obravnavo. Revimo prevzame
            ponavljajoče se organizacijske naloge.`,
            desc2: `Rutinsko izvajanje načrtov, vodenje vaj in spremljanje napredka
            so strukturirani in avtomatizirani, kar omogoča več časa za zahtevnejše
            primere, poglobljene odnose s pacienti in višjo kakovost obravnave.`,
            imp: "Vi ostajate strokovnjak. Revimo omogoča širši doseg vašega znanja.",
        },
        tableOfCon: {},
        treatmentP: {
            s: "Načrti obravnave",
            header: "Oblikujte načrte, prilagojene posameznemu pacientu.",
            desc: `Vsak pacient je edinstven. Revimo omogoča popoln nadzor nad
            vsemi elementi načrta — od izbire vaj do logike napredovanja — ter
            takojšnjo dostavo v pacientov uporabniški račun.`,
            PERKS: {
                title1: "Oblikovanje prilagojenega načrta",
                desc1: "Izberite vaje iz baze ter določite ponovitve, serije, pogostost in cilje napredovanja na enem mestu.",

                title2: "Dodelitev pacientu",
                desc2: "Načrt je takoj dostopen v pacientovem profilu in pripravljen za izvajanje.",

                title3: "Spremljanje na daljavo",
                desc3: "Spremljajte izvajanje, doslednost in povratne informacije brez dodatne komunikacije.",

                title4: "Prilagajanje ob napredku",
                desc4: "Po potrebi posodobite vaje ali zahtevnost — spremembe se takoj odražajo pri pacientu.",
            },
        },
        whyR: {
            s: "Zakaj Revimo",
            header: "Vse, kar potrebujete. Brez odvečnih funkcionalnosti.",
            desc1: `Revimo temelji na vprašanju: kako zmanjšati čakalne dobe,
            ne da bi pri tem ogrozili kakovost in strokovnost obravnave?`,
            desc2: "To vpliva tako na paciente kot tudi na fizioterapevte.",
            desc3: "Cilj Revima je izboljšati fizioterapijo za obe strani.",
            PERKS: {
                t1: "Več časa za zahtevnejše primere",
                d1: "Platforma prevzame rutinske naloge in spremljanje pacientov.",

                t2: "Večja doslednost pacientov",
                d2: "Strukturirani načrti z jasnimi navodili povečujejo verjetnost rednega izvajanja vaj.",

                t3: "Povezanost med obravnavami",
                d3: "Omogočen je vpogled v napredek in težave brez potrebe po dodatnih stikih.",

                t4: "Razvito v sodelovanju s stroko",
                d4: "Funkcionalnosti so oblikovane skupaj z licenciranimi strokovnjaki.",

                t5: "Strokovno utemeljena vsebina",
                d5: "Vaje temeljijo na dokazih in so strokovno pregledane.",

                t6: "Prilagodljivo obsegu vaše prakse",
                d6: "Platforma učinkovito podpira tako manjše kot večje število pacientov.",
            },
        },

    },
} as const;